import React from 'react';
import styled from 'styled-components';
import EsApplyPckgProd from './EsApplyPckgProd';

const EsApplyPckgProdBoxUlBlock = styled.ul`
    height: 304px;
    padding-top: 10px;
    padding-right: 10px;
    margin-top: 40px;
    margin-left: -37px;
    overflow: auto; 

    ::after {
        content: "";
        display: block;
        clear: both;
    }

    ::-webkit-scrollbar {
        width: 4px;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 5px;
    }

    :-webkit-scrollbar-track {
        background-color: #f4f4f4;
    }
`;

const EsApplyPckgProdBox = ({ esApplyProdList }) => {

    return (
        <EsApplyPckgProdBoxUlBlock>
            {
                esApplyProdList.map((prodinfo, index) => {
                    return (<EsApplyPckgProd key={index} prodinfo={prodinfo} />);
                })
            }
        </EsApplyPckgProdBoxUlBlock>

    );
};

export default EsApplyPckgProdBox;